import { MouseEvent, useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { CollectionsModel } from '@/types';
import { EditIcon, DeleteIcon, FolderIcon, ThreeDotsVerticalIcon } from '../svg';
import styles from '../Favorites.module.scss';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#1579FF33',
  width: '32px',
  height: '32px',
  color: '#2A3842',
  fontSize: '18px',
  position: 'absolute',
  top: '10px',
  right: '10px',

  '&:hover': {
    boxShadow: '0 0 7px 2px rgba(1, 92, 213, .3)',
    background: 'linear-gradient(90deg, #015cd5 0%, #016af8 100%)',
    color: '#ffffff',
  },
  [theme.breakpoints.down('sm')]: {
    width: '30px',
    height: '30px',
  },
}));

export const CollectionItem = ({
  collection,
  onSelectionClick,
}: {
  collection: CollectionsModel;
  onSelectionClick: (id: string, titleText: string, dialogType: 'delete' | 'rename') => void;
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const handleClickMenu = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const openDialog = async (e: any, dialogType: 'delete' | 'rename') => {
    e.preventDefault();
    e.stopPropagation();
    onSelectionClick(collection.id, collection.collectionName, dialogType);
    handleClose();
  };

  return (
    <Stack spacing={1}>
      <Box
        sx={{
          position: 'relative',
          borderRadius: '20px',
          border: '1px solid #C5DFFF',
          height: '137px',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FolderIcon
          onClick={() => navigate(`/favorites/collection/${collection.id}`)}
          style={{ cursor: 'pointer' }}
        />
        <StyledIconButton size='small' onClick={handleClickMenu}>
          <ThreeDotsVerticalIcon />
        </StyledIconButton>
        <Menu
          sx={{
            marginTop: '10px',
            '.MuiMenuItem-root': {
              display: 'flex',
              gap: '12px',
              color: '#2A3842',
              transition: 'color 0.2s ease',
              '&:hover': {
                color: '#1650FF',
              },
            },
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={(e) => openDialog(e, 'rename')}>
            <EditIcon />
            Rename
          </MenuItem>
          <MenuItem onClick={(e) => openDialog(e, 'delete')}>
            <DeleteIcon />
            Delete
          </MenuItem>
        </Menu>
      </Box>
      <Typography
        sx={{ fontSize: 14 }}
        onClick={() => navigate(`/favorites/collection/${collection.id}`)}
        className={styles.collectionTitle}
      >
        {collection.collectionName}
      </Typography>
    </Stack>
  );
};
